import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import TextField from "@material-ui/core/TextField";

const getLocalizedSeparators = () => (
    navigator.language.indexOf('de') > -1
        ? {decimalSeparator: ',', thousandSeparator: '.'}
        : {thousandSeparator: true /* use default */}
);

const NumberFormatCustom = (props) => {
    const {value, inputRef, onChange, ...other} = props;

    return (
        <NumberFormat
            {...other}
            {...getLocalizedSeparators()}
            defaultValue={value} // do not bind as "value" !
            getInputRef={inputRef}
            onValueChange={values => {
                onChange({
                    target: {
                        id: other.id,
                        name: other.name,
                        value: values.floatValue,
                    },
                });
            }}
        />
    );
};

NumberFormatCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    fixedDecimalScale: PropTypes.bool,
    decimalScale: PropTypes.number,
};

NumberFormatCustom.defaultProps = {
    fixedDecimalScale: true,
    decimalScale: 2,
};

const FormNumber = ({label, name, error, touched, onChange, onBlur, ...props}) => {

    const {
        // Number format props.
        fixedDecimalScale,
        decimalScale,
        format,
        mask,

        // Gather the rest.
        ...other
    } = props;

    return (
        <TextField
            id={name}
            name={name}
            label={label}
            placeholder={label}
            onChange={onChange}
            onBlur={onBlur}
            error={touched && !!error}
            helperText={touched && error}
            InputProps={{
                // Applied to the MUI Input element
                inputComponent: NumberFormatCustom,
            }}
            inputProps={{
                // Applied to the native input element
                // thus its applied to our NumberFormatCustom component
                fixedDecimalScale,
                decimalScale,
                format,
                mask,
            }}
            {...other}
        />
    );
};

FormNumber.defaultProps = {
    fullWidth: true,
};

export default FormNumber;



// WEBPACK FOOTER //
// ./resources/assets/js/components/Form/FormNumber.js